'use client';
import { memo, type MouseEvent } from 'react';
import { SvgLoader } from '@/app/elements/svg/loader';

type VideoSoundButtonComponentProps = {
    isMuted: boolean;
    onButtonClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

export const VideoSoundButtonComponent = memo(function VideoSoundButtonComponent({
    isMuted,
    onButtonClick
}: VideoSoundButtonComponentProps) {
    return (
        <div className="video-sound-button-component" onClick={onButtonClick}>
            {isMuted ? (
                <SvgLoader iconName="sound-off" className="sound-button-off" data-test-id="mute-trailer-sound-button" />
            ) : (
                <SvgLoader iconName="sound-on" className="sound-button-on" data-test-id="unmute-trailer-sound-button" />
            )}
        </div>
    );
});
